module.exports = {
  noHeaderFooterRoutes: ['/demo'],
};
